//
//
//
//
//

import Claims from './claims'
export default {
    name: "illustrate",
    data(){
        return {
        }
    },
     props: {
        illustInfo: {
            type: Array,
            default() { return []}
        },
        qybFlag: {
            type: Boolean,
            default() { return true}
        },
        claimsShow: {
            type: Boolean,
            default() { return true}
        },
    },
    components:{
      Claims
    },
    created() {
    },
    mounted(){
    },
    methods:{
        addHeight(){
            if(this.$refs.illustrate.offsetHeight - document.body.offsetHeight <0){
                this.$refs.illustrate.style.minHeight  = document.body.offsetHeight -this.$parent.navHeight +'px'
            }
        },
    }
}
